import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_LANGUAGE } from '@modeso/aumico-lib-core-fe';
import { IDynamicKeyValue, ViewMode } from '@modeso/types__aumico-lib-core-be';
import { ComponentsOptionsDTO, INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import Debug from 'debug';
import { NotesTypesHelper } from '../../helpers/notesTypes.helper';

const debug = Debug('aumico:aumico-lib-notes-fe:NotesTemplatePreviewComponent');

@Component({
    selector: 'aumico-notes-template-preview',
    templateUrl: 'notesTemplatePreview.component.html',
    styleUrls: ['notesTemplatePreview.component.scss'],
})
export class NotesTemplatePreviewComponent implements OnInit {
    public defaultLanguage = DEFAULT_LANGUAGE;

    @Input() selectedNotesTypes: INotesTypeEntityDTO[] = [];
    @Input() currentLanguage = 'de-ch';
    @Input() viewMode: ViewMode = ViewMode.EDIT;

    constructor(private notesTypesHelper: NotesTypesHelper) {}

    ngOnInit(): void {
        debug('ngOnInit');
    }

    getComponentOptionsOfSelectedComponents(
        componentOptions: ComponentsOptionsDTO[],
    ): Map<string, Omit<ComponentsOptionsDTO, 'componentName'>> {
        return this.notesTypesHelper.getComponentOptions(componentOptions);
    }

    getTitleByCurrentLanguage(title: IDynamicKeyValue): string {
        return title[this.defaultLanguage];
    }

    getSelectedComponentsNames(componentOptions: ComponentsOptionsDTO[]): string[] {
        return componentOptions.map((option: ComponentsOptionsDTO) => option.componentName);
    }
}
